/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import getAllUrlParams from '../../util/get-url-params';
import Page from '../../features/login';
import App from '../../app';
import GeoBlocker from '../../features/geo-blocker';

const removeLoader = () => {
  const loader = document.getElementById('loader');
  if (loader) {
    setTimeout(() => {
      loader.classList.add('fade-out');
      setTimeout(() => {
        if (loader.parentNode) {
          loader.parentNode.removeChild(loader);
        }
      }, 2000);
    }, 300);
  }
};

function LoginPage(props) {
  const { match, location, config } = props || {};
  const { params } = match;
  let { hash } = location;
  if (hash.startsWith('#/')) {
    hash = hash.replace('#/', '');
  } else if (hash.startsWith('#')) {
    hash = hash.replace('#', '');
  }
  const searchParams = getAllUrlParams(location.search);
  const page = () => (
    <Page
      {...{
        ...params,
        ...searchParams,
        config,
        hash,
        removeLoader,
      }}
    />
  );

  return <GeoBlocker config={config} availableComponent={page} onComplete={removeLoader} />;
}

const root = createRoot(document.getElementById('root'));

root.render(
  <App path="./" page="login">
    {(config) => {
      return (
        <Router>
          <Switch>
            {config && <Route key="login" component={(props) => LoginPage({ ...props, config })} />}
          </Switch>
        </Router>
      );
    }}
  </App>
);
